//https://www.npmjs.com/package/node-fetch

export default {};
